const EMAIL =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const MIN8CHAR = /^(?=.[a-zA-Z0-9]*).{6,}$/;
const UPPERCASE_LOWERCASE = /(?=.*[A-Z])(?=.*[a-z])/;
const DIGIT_CHARACTER = /(?=.*\d)(?=.*[!@#$%^&*()\-_\\{}[\]+='~"`;:><,.?|€£])/;

export { EMAIL, MIN8CHAR, UPPERCASE_LOWERCASE, DIGIT_CHARACTER };
